import React from 'react';
import logo from '../../icons/Component 2.png';
import facebook from '../../icons/facebook.png';
import { useNavigate } from 'react-router';
import "./site.css"


function EmBreve(): React.JSX.Element {

  const navigate = useNavigate();

  const handleSite = async (event: any) => {

    navigate("/");

  };

  const handleContacts = async (event: any) => {

    navigate("/Contacts");

  };

  return (
    <>
      <main>
        <header>
          <div className='line01'>
            <div className='headerLogo'>
              <img src={logo} alt="logo" />
            </div>
            <div className='mainButtonsB'>
              <button onClick={handleContacts} className='loginButton01'>Registro/Login</button>
            </div>
          </div>

          <div className='headerButtons'>
            <div className='mainButtons'>
              <div className='mainButtonsA'>
                <a href="https://internetalfa.com.br/" className='homeButton'>Início</a>
                <a href="https://internetalfa.com.br/">Internet Alfa</a>
                <a href="https://internetalfa.com.br/">Alfa Celular</a>
                <a href="https://internetalfa.com.br/">FAQ</a>
                <a href="https://internetalfa.com.br/">Quem Somos</a>
                <a href="https://mk.internetalfa.com.br/sac/login/?sys=SAC">SAC</a>
              </div>
              <div className='mainButtonsB'>
                <button onClick={handleContacts} className='loginButton02'>Registro/Login</button>
              </div>

            </div>

          </div>

        </header>
        <body>
          <div className='emBreve'>
            <div className='emBreveTitle'>
              <h1>Em Breve</h1>
            </div>
            <div className='emBreveDescription'>
              <p>Estamos trabalhando para melhorar cada vez mais nossos serviços. Em breve você terá controle de 100% do seu plano através do nosso sistema!</p>
            </div>
            <div className='emBreveButton'>
              <button onClick={handleSite}>Voltar ao início</button>
            </div>
          </div>
        </body>
        <footer>
          <div className='footer'>
            <div className='endereco'>
              <h1>ALFA NETWORK</h1>
              <p>RUA CARLOS SCHUMACKER Nº 314, SALA 01 - JARDIM DOS FRANCOS, SÃO PAULO, BRASIL</p>
              <p>CNPJ: 13.026.557/0001-43</p>
            </div>
            <div>
              <span className="separadorVertical"></span>
            </div>
            <div className='contatos'>
              <div>
                <span><p>Entre em contato conosco</p></span>
              </div>
              <div className='contacts'>
                <div className='phones'>
                  <span><p>Telefones:</p></span>
                  <p>(11) 3983-0314</p>
                  <p>(11) 3984-0896</p>
                  <p>0800 771 03148</p>
                </div>
                <div>
                  <div>
                    <span><p>Redes Sociais:</p></span>
                    <div className='socialMedia'>
                      {/* <img src="#" alt="wpp-icon" />
                      <img src="" alt="ig-icon" /> */}
                      <a href="https://www.facebook.com/AlfaTechnologies" rel='noreferrer' target='_blank'><img src={facebook} alt="fb-icon" /></a>
                    </div>
                  </div>
                  <div className='email'>
                    <span><p>E-mail:</p></span>
                    <a href="mailto:contato@internetalfa.com.br">contato@internetalfa.com.br</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='termos'>
            <a href="/Contacts" id='termos'>Termos de Uso & Privacidade</a>
            <div className='copy' id='maincode'>
              <p>&copy; Copyright - All Rights Reserved By Alfa Networking | <a href="https://maincode.dev"> Powered By  MainCode</a></p>
            </div>
          </div>
        </footer>
      </main>
    </>
  );
}

export default EmBreve;